import React, { useEffect, useState } from 'react';
import Hidden from '@mui/material/Hidden';
import { useLazyQuery } from '@apollo/client';
import { ROUTES_MPTT_QUERY } from 'Graph/SiteGraph';
import Storage from 'src/utils/storage/storage';
import _ from 'lodash';
import SideDrawer from '../../drawer/SideDrawer';
import AppDrawer from '../appDrawer/app-drawer';

export default function UserSidebar({ ...props }) {
  const [allPageMPTTData, setAllPageMPTTData] = useState(null);

  // local state for source id
  const [sourceIdValue, setSourceIdValue] = useState(
    Storage.getSourceId().source
  );

  const [getLazyMPTTPages, lazyMPTTPages] = useLazyQuery(ROUTES_MPTT_QUERY, {
    // notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only', // Used for first execution
    nextFetchPolicy: 'cache-first' // Used for subsequent executions
  });

  // TODO: remove this code after testing
  // useEffect(() => {
  // useEffect(() => {
  //   getLazyMPTTPages({
  //     variables: {
  //       sidebar: true,
  //       reqNodeName: 'SRM',
  //       level: 2,
  //       sourceId: sourceIdValue.toString()
  //     },
  //     onCompleted: (pageData) => {
  //       // console.log("this is mptt data from graphql🔋🔋", pageData)
  //       const defaultPageList = pageData.defaultRoutesMptt;
  //       const appPageList = pageData.appRoutesMptt;
  //       const pageList = [...defaultPageList, ...appPageList];
  //       const dedupedData = _.uniqWith(pageList, _.isEqual).filter(
  //         (item) => item
  //       );
  //       // console.log("this is deduped data from graphql🔋", dedupedData)
  //       setAllPageMPTTData(dedupedData);
  //     }
  //   });
  // }, [sourceIdValue])

  return (
    // TODO: clean the code after testing
    <React.StrictMode>
      <Hidden mdDown>
        {/* <SideDrawer variant='permanent' data={allPageMPTTData} {...props} /> */}
        <AppDrawer />
      </Hidden>
      <Hidden mdUp>
        {/* <SideDrawer variant='temporary' data={allPageMPTTData} {...props} /> */}
        <AppDrawer />
      </Hidden>
    </React.StrictMode>
  );
}
